import axios from 'axios';

/**
 * Get form data based on input parameters.
 * @param params
 * @return {URLSearchParams}
 */
const getFormData = (params) => {
  const defaults = {
    quantity: 0,
    code: '',
  };
  const options = Object.assign(defaults, params);
  const formData = new URLSearchParams();

  formData.append('qty', options.quantity);
  formData.append('productCodePost', options.code);

  return formData;
};

const CartApi = {
  /**
   * Add a product to cart.
   * @param params
   * @return {AxiosPromise}
   */
  add (params) {
    const formData = getFormData(params);
    return new Promise((resolve, reject) => {
      axios({
        url: '/cart/add',
        method: 'POST',
        data: formData,
        headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
      }).then(response => {
        resolve(response.data);
      }).catch(reason => {
        reject(reason);
      });
    });
  },
};

export {CartApi};
